import { getStoriesByContentType } from "@website-builder/utilities-index";

export const contentType = "Blog";

export default ({ header }, { storyList = [] }) => {
	// filter by content type blog
	const list = storyList?.[contentType] || [];
	let categoriesMap = getBlogCategories(list);
	return {
		header,
		categoriesMap,
	};
};

export const getBlogCategories = (list) => {
	let categoriesMap = {};
	list?.forEach(({ full_slug: fullSlug }) => {
		const categories = fullSlug.split("/");
		const n = categories.length - 1;
		let filterSlug = categories[0];
		categories.forEach((type, i) => {
			if (i !== 0 && i !== n) {
				filterSlug += `/${type}`;
				if (!categoriesMap[type]) {
					categoriesMap[type] = {
						filterSlug,
					};
				}
			}
		});
	});
	return categoriesMap;
};
